{
  "version": 1,
  "asset_id": "36d5fca9-e068-44bd-bf41-b70af9fda196",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/36d5fca9-e068-44bd-bf41-b70af9fda196/sleeve-to-bypass-completed-es.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/36d5fca9-e068-44bd-bf41-b70af9fda196/sleeve-to-bypass-completed-es.png",
  "original_filename": "sleeve-to-bypass-completed-es.png",
  "size": 335517,
  "content_type": "image/png",
  "created_at": "2026-10-05T12:46:37Z"
}
